<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <qcc-search-box
          slot="cu_name"
          :label="customLabel.cu_name || '客户名称'"
          placeholder="请输入客户名称"
          v-model="form.main.cu_name"
          @select="onQccSelect($event)"
          @change="custChange"
        ></qcc-search-box>
        <div class="weui-cell" slot="cu_nsrzh">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_nsrzh || "社会信用代码"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_nsrzh"
              placeholder="请填写"
            />
          </div>
        </div>
        <combo-field
          slot="cu_type"
          :label="customLabel.cu_type || '客户类型'"
          v-model="form.main.cu_type"
          url="/api/document/customerkind/getCombo"
        />
        <div class="weui-cell" slot="cu_bankaccount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_bankaccount || "开户银行"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_bankaccount"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="cu_bankcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_bankcode || "开户账号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_bankcode"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="cu_invoiceinfo">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_invoiceinfo || "开票地址"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_invoiceinfo"
              placeholder="请填写"
            />
          </div>
        </div>
        <combo-field
          slot="cu_industry"
          :label="customLabel.cu_industry || '行业类型'"
          v-model="form.main.cu_industry"
          url="/api/document/industry/getCombo"
        />
        <combo-field
          slot="cu_source"
          :label="customLabel.cu_source || '商机线索'"
          v-model="form.main.cu_source"
          url="/api/document/genericoption/getCombo"
          :params="{bizType: caller, fieldName: 'cu_source'}"
        />
      </custom-layout>

      <div class="weui-cells_hd">交易信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <currency-field
          slot="cu_currency"
          :label="customLabel.cu_currency || '交易币别'"
          v-model="form.main.cu_currency"
          :use-default="true"
        />
        <div class="weui-cell" slot="cu_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_taxrate || "税率(%)"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_taxrate"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="cu_credit">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_credit || "信用额度(元)"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_credit"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="cu_credit_t">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_credit_t || "临时信用额度"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_credit_t"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field
          v-model="form.main.cu_payments"
          @select="onSelectPayment($event,0)"
          slot="cu_payments"
          :label="customLabel.cu_payments || '收款方式1'"
        />
        <div class="weui-cell" slot="cu_paydelay">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_paydelay || "收款延迟天数1"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_paydelay"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field
          v-model="form.main.cu_payments1"
          @select="onSelectPayment($event,1)"
          slot="cu_payments1"
          :label="customLabel.cu_payments1 || '收款方式2'"
        />
        <div class="weui-cell" slot="cu_paydelay1">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_paydelay1 || "收款延迟天数2"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_paydelay1"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field
          v-model="form.main.cu_payments2"
          @select="onSelectPayment($event,2)"
          slot="cu_payments2"
          :label="customLabel.cu_payments2 || '收款方式3'"
        />
        <div class="weui-cell" slot="cu_paydelay2">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_paydelay2 || "收款延迟天数3"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_paydelay2"
              placeholder="请填写"
            />
          </div>
        </div>
        <employee-field
          :label="customLabel.cu_sellername || '业务员'"
          v-model="form.main.cu_sellername"
          @select="onSelectEmployee"
          slot="cu_sellername"
        />
        <account-check-box  slot="cu_othersellers" :label="'其他业务员'" v-model="form.main.cu_othersellers" @select="onSelectCcrecipients2" />
        <department-field
          slot="cu_dpname"
          :label="customLabel.cu_dpname || '事业部门'"
          v-model="form.main.cu_dpname"
          @select="onSelectDepartment"
        />
        
        <div class="weui-cell" slot="cu_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_remark || "备注"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_remark"
              placeholder="请填写"
            />
          </div>
        </div>
        <custom-field
          :label="customLabel.cu_text1 || '自定义字段1'"
          v-model="form.main.cu_text1"
          :caller="caller"
          fieldName="cu_text1"
          slot="cu_text1"
          hidden="true"
        />
        <custom-field
          :label="customLabel.cu_text2 || '自定义字段2'"
          v-model="form.main.cu_text2"
          :caller="caller"
          fieldName="cu_text2"
          slot="cu_text2"
          hidden="true"
        />
        <custom-field
          :label="customLabel.cu_text3 || '自定义字段3'"
          v-model="form.main.cu_text3"
          :caller="caller"
          fieldName="cu_text3"
          slot="cu_text3"
          hidden="true"
        />
        <custom-field
          :label="customLabel.cu_text4 || '自定义字段4'"
          v-model="form.main.cu_text4"
          :caller="caller"
          fieldName="cu_text4"
          slot="cu_text4"
          hidden="true"
        />
        <custom-field
          :label="customLabel.cu_text5 || '自定义字段5'"
          v-model="form.main.cu_text5"
          :caller="caller"
          fieldName="cu_text5"
          slot="cu_text5"
          hidden="true"
        />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items1"
        :key="'1-' + xindex"
      >
        <div class="weui-cells__title">
          <span>联系人{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem1(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-cell" slot="cc_name">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.cc_name || "联系人"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.cc_name"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="cc_tel">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.cc_tel || "电话"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.cc_tel"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="cc_email">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.cc_email || "邮箱"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.cc_email"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell weui-cell_active weui-cell_switch"
              slot="cc_default"
            >
              <div class="weui-cell__bd">
                {{ customLabel.cc_default || "默认联系人" }}
              </div>
              <div class="weui-cell__ft">
                <input
                  class="weui-switch"
                  v-model="item.cc_default"
                  type="checkbox"
                  v-bind:true-value="1"
                  v-bind:false-value="0"
                  @change="onChangeDefault1(item, xindex)"
                />
              </div>
            </div>
            <custom-field
              :label="customLabel.cc_text1 || '自定义字段1'"
              v-model="item.cc_text1"
              :caller="caller"
              fieldName="cc_text1"
              slot="cc_text1"
              hidden="true"
            />
            <custom-field
              :label="customLabel.cc_text2 || '自定义字段2'"
              v-model="item.cc_text2"
              :caller="caller"
              fieldName="cc_text2"
              slot="cc_text2"
              hidden="true"
            />
            <custom-field
              :label="customLabel.cc_text3 || '自定义字段3'"
              v-model="item.cc_text3"
              :caller="caller"
              fieldName="cc_text3"
              slot="cc_text3"
              hidden="true"
            />
            <custom-field
              :label="customLabel.cc_text4 || '自定义字段4'"
              v-model="item.cc_text4"
              :caller="caller"
              fieldName="cc_text4"
              slot="cc_text4"
              hidden="true"
            />
            <custom-field
              :label="customLabel.cc_text5 || '自定义字段5'"
              v-model="item.cc_text5"
              :caller="caller"
              fieldName="cc_text5"
              slot="cc_text5"
              hidden="true"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items1.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem1"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items2"
        :key="'2-' + xindex"
      >
        <div class="weui-cells__title">
          <span>送货地址{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem2(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-cell" slot="ca_address">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ca_address || "送货地址"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.ca_address"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="ca_person">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ca_person || "联系人"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.ca_person"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div class="weui-cell" slot="ca_phone">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.ca_phone || "联系电话"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.ca_phone"
                  placeholder="请填写"
                />
              </div>
            </div>
            <div
              class="weui-cell weui-cell_active weui-cell_switch"
              slot="ca_default"
            >
              <div class="weui-cell__bd">
                {{ customLabel.ca_default || "默认地址" }}
              </div>
              <div class="weui-cell__ft">
                <input
                  class="weui-switch"
                  v-model="item.ca_default"
                  type="checkbox"
                  v-bind:true-value="1"
                  v-bind:false-value="0"
                  @change="onChangeDefault2(item, xindex)"
                />
              </div>
            </div>
            <custom-field
              :label="customLabel.ca_text1 || '自定义字段1'"
              v-model="item.ca_text1"
              :caller="caller"
              fieldName="ca_text1"
              slot="ca_text1"
              hidden="true"
            />
            <custom-field
              :label="customLabel.ca_text2 || '自定义字段2'"
              v-model="item.ca_text2"
              :caller="caller"
              fieldName="ca_text2"
              slot="ca_text2"
              hidden="true"
            />
            <custom-field
              :label="customLabel.ca_text3 || '自定义字段3'"
              v-model="item.ca_text3"
              :caller="caller"
              fieldName="ca_text3"
              slot="ca_text3"
              hidden="true"
            />
            <custom-field
              :label="customLabel.ca_text4 || '自定义字段4'"
              v-model="item.ca_text4"
              :caller="caller"
              fieldName="ca_text4"
              slot="ca_text4"
              hidden="true"
            />
            <custom-field
              :label="customLabel.ca_text5 || '自定义字段5'"
              v-model="item.ca_text5"
              :caller="caller"
              fieldName="ca_text5"
              slot="ca_text5"
              hidden="true"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items2.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem2"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.cu_attach" ref="cu_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboField from "@/components/field/ComboField.vue";
import FileField from "@/components/field/FileField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import QccSearchBox from "@/components/field/QccSearchBox";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";
import AccountCheckBox from "@/components/field/AccountCheckBox.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    ComboField,
    FileField,
    CurrencyField,
    PaymentField,
    EmployeeField,
    DepartmentField,
    QccSearchBox,
    CustomField,
    AccountCheckBox
  },
  data() {
    return {
      baseUrl: "/api/document/customer",
      codeField: "cu_code",
      statusField: "cu_audit_status_code",
      caller: "Customer",
      xtype: "document-customer-formpanel",
      form: {
        main: {
          cu_name: "",
          cu_taxrate: 0,
          cu_dpname: null,
        },
        items1: [
          {
            cc_default: 1,
          },
        ],
        items2: [
          {
            ca_default: 1,
          },
        ],
      },
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main,
        items1 = me.form.items1,
        items2 = me.form.items2;
      if (!main.cu_name) {
        me.$weui.topTips("请填写客户名称", 2000);
      } else if (!main.cu_currency) {
        me.$weui.topTips("请选择默认币种", 2000);
      } else if (!main.cu_payments) {
        me.$weui.topTips("请选择收款方式", 2000);
      } else if (typeof main.cu_taxrate === "undefined") {
        me.$weui.topTips("请填写税率", 2000);
      } else {
        var count1 = 0,
          count2 = 0;
        items1.forEach(function (item) {
          if (!item.cc_name) {
            me.$weui.topTips(`第${count1 + 1}行未填写联系人`, 2000);
            return false;
          } else if (!item.cc_tel) {
            me.$weui.topTips(`第${count1 + 1}行未填写联系人电话`, 2000);
            return false;
          } else {
            count1++;
            item.cc_detno = count1;
          }
        });
        items2.forEach(function (item) {
          if (!item.ca_address) {
            me.$weui.topTips(`第${count2 + 1}行未填写送货地址`, 2000);
            return false;
          } else {
            count2++;
            item.ca_detno = count2;
          }
        });
        if (count1 == items1.length && count2 == items2.length) {
          me.p_save();
        }
      }
    },
    onSelectPayment(selection, index) {
      var me = this,
        main = me.form.main;
      main['cu_paymentsid' + (index ? index : '')] = selection.id;
      main['cu_paymentscode' + (index ? index : '')] = selection.pa_code;
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.cu_sellerid = selection.id;
      main.cu_sellercode = selection.em_code;
      main.cu_dpid = selection.em_dpid;
      main.cu_dpcode = selection.dp_code;
      main.cu_dpname = selection.dp_name;
    },
    onSelectDepartment(selection) {
      var me = this,
        main = me.form.main;
      main.cu_dpid = selection.id;
      main.cu_dpcode = selection.dp_code;
      main.cu_dpname = selection.dp_name;
    },
    /**
     * 删除行
     */
    removeItem1(index) {
      var me = this,
        items = me.form.items1;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 删除行
     */
    removeItem2(index) {
      var me = this,
        items = me.form.items2;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem1() {
      var me = this,
        items = me.form.items1;
      items.push({
        cc_default: 0,
      });
    },
    /**
     * 新增行
     */
    addItem2() {
      var me = this,
        items = me.form.items2;
      items.push({
        ca_default: 0,
      });
    },
    onChangeDefault1(item, index) {
      if (item.cc_default) {
        var me = this,
          items = me.form.items1;
        for (var i = 0, len = items.length; i < len; i++) {
          if (i != index) {
            items[i].cc_default = 0;
          }
        }
      }
    },
    onChangeDefault2(item, index) {
      if (item.ca_default) {
        var me = this,
          items = me.form.items2;
        for (var i = 0, len = items.length; i < len; i++) {
          if (i != index) {
            items[i].ca_default = 0;
          }
        }
      }
    },
    /**
     * 企查查模糊查询选择
     */
    onQccSelect(company) {
      var code = company.creditCode;
      if (!code || !code.length) {
        code = company.no;
      }
      this.form.main.cu_nsrzh = code;
      this.form.main.cu_legal_person = company.operName;
    },
    custChange() {
      this.form.main.cu_nsrzh = null;
    },
    onSelectCcrecipients(selection) {
      let main = this.form.main;
      main.cu_brands = selection.map((item) => item.value).join(",");
    },
    onSelectCcrecipients2(selection) {
      let main = this.form.main
      main.cu_othersellers = selection.map(item => item.em_name).join(','),
      main.cu_othersellerids = selection.map(item => item.id).join(',')
    },
  },
};
</script>
